<template>
  <div class="edit-recipe wrapper">

    <div>
      <BaseErrors :errors="errors"></BaseErrors>

      <div class="row">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Brew session details</h5>
              <div v-if="loading" class="text-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <div v-if="loggedIn && brewSession" class="brew-session-wrapper">
                <p>Date: {{brewSession.date}}</p>
                <p>Recipe: <router-link :to="{ name: 'recipe-show', params: { id: brewSession.recipeId }}">{{brewSession.recipeName}}</router-link></p>
                <p>name: {{brewSession.name}}</p>
                <p v-if="brewSession.abv">Calculated ABV: {{brewSession.abv | abv}}</p>

                <form @submit.prevent="updateBrewSession">
                    <div class="row">
                    <div class="form-group col">
                      <label for="brew-session-date">Date</label>
                      <input v-model="date" class="form-control" type="date" id="brew-session-date">
                    </div>
                    </div>
                    <div class="row">
                      <div class="measured-inputs">

                      <div class="form-group col">
                      <label for="brew-session-og">OG</label>
                      <input v-model="og" class="form-control" type="number" step="0.001" id="brew-session-og">
                    </div>

                    <div class="form-group col">
                      <label for="brew-session-fg">FG</label>
                      <input v-model="fg" class="form-control" type="number" step="0.001" id="brew-session-fg">
                    </div>

                    <div class="form-group col">
                      <label for="brew-session-volume">Volume ({{batchVolumeUnit()}})</label>
                      <input v-model="volume" class="form-control" type="number" step="0.01" id="brew-session-volume">
                    </div>
                  </div>
                  </div>

                  <div>
                    <button type="submit" class="btn btn-primary btn-sm">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Brew session notes</h5>
              <div v-if="loggedIn && brewSession" class="brew-session-notes">
                <ul class="notes-list">
                  <li v-for="note in notes" @click.prevent="showNotesModal = note">
                    <span class="note-date">{{note.date}}</span>
                    <span class="note-content" v-html="note.content"></span>
                    <a href="#"
                       class="delete-note"
                       :data-id="note.id"
                       @click.prevent.stop="deleteNote">
                      <BaseIcon name="delete"
                                title="Delete this item"
                                width="20"
                                height="20"></BaseIcon>
                    </a>
                  </li>
                </ul>

                <form @submit.prevent="addNote">
                  <div class="form-group">
                    <label for="brew-session-note">Note</label>
                    <textarea v-model="note"
                              class="form-control"
                              v-bind:class="{ 'is-invalid': errorFields['BrewSession_notes'] }"
                              id="brew-session-note"></textarea>
                    <div class="invalid-feedback">{{errorFields['BrewSession_notes']}}</div>

                  </div>

                  <div>
                    <button type="submit" class="btn btn-primary btn-sm">Add note</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>



        <div class="col-md-6 col-xl-4">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Brew record data</h5>
                  <p><FermGraph :brewSessionId="id"></FermGraph></p>
                  <p class="brew-record-data-actions">
                    <button :disabled="brewSession && brewSession.records === 0" @click.prevent="exportBrewSessionData()" type="submit" class="btn btn-secondary btn-sm">Export</button>
                    <button :disabled="brewSession && brewSession.records === 0" @click.prevent="wipeBrewSessionData()" type="submit" class="btn btn-danger btn-sm">Wipe brew data</button>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Push brew records</h5>

                  <BrewRecordsPush
                    v-on:update-brew-session="fetchBrewSession()"
                    :brewSessionId="id"></BrewRecordsPush>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Import brew records</h5>

                  <BrewRecordsImport :brewSessionId="id"></BrewRecordsImport>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <notes-modal
      v-if="showNotesModal"
      v-on:close-modal="fetchNotes"
      :note="showNotesModal"
      :brewSessionId="brewSession.id" />
  </div>
</template>

<script>
    import { HTTP } from '@/lib/http';
    import { EventBus } from '@/lib/event-bus.js';
    import NotesModal  from '@/components/modals/NotesModal';
    import BrewRecordsImport from "@/components/BrewRecordsImport";
    import BrewRecordsPush from "@/components/BrewRecordsPush";
    import FermGraph from "@/components/FermGraph";
    export default {
        name: "streams",
        components: {
            NotesModal,
            BrewRecordsImport,
            FermGraph,
            BrewRecordsPush
        },
        data() {
            return {
                brewSession: null,
                notes: null,
                errors: null,
                loading: true,
                loadingNotes: true,
                loggedIn: false,
                id: null,
                og: null,
                fg: null,
                note: null,
                volume: null,
                showNotesModal: null,
                date: null,
                errorFields: {}
            };
        },
        methods: {
            fetchBrewSession() {
                HTTP.get(`brew-sessions/${this.id}`)
                    .then(response => {
                      debugger
                        this.brewSession = response.data.data;
                        this.og = this.brewSession.og;
                        this.fg = this.brewSession.fg;
                        this.date = this.brewSession.date;
                        this.volume = this.$options.filters.volume(this.brewSession.volume);
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
          wipeBrewSessionData: function () {
            if (confirm('Are you sure?')) {
              HTTP.post(`brew-sessions/${this.id}/wipe`)
                .then(response => {
                  EventBus.$emit(`brew-session-data-changed:${this.id}`, true)
                })
                .catch(err => {
                  this.errors = [err.response.data.errors];
                })
                .then(() => {
                  // this.loading = false;
                });
            }
          },
          exportBrewSessionData() {
             HTTP.post(`brew-sessions/${this.id}/export`,{}, { responseType: 'blob'})
                .then(response => {
                  let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  let fileLink = document.createElement('a');

                  fileLink.href = fileURL;
                  fileLink.setAttribute('download', 'file.csv');

                  document.body.appendChild(fileLink);
                  fileLink.click();
                })
                .catch(err => {
                  this.errors = [err.response.data.errors];
                })
                .then(() => {
                  // this.loading = false;
                });
          },
            fetchNotes() {
                this.showNotesModal = false;

                HTTP.get("brew-sessions/" + this.id + "/notes")
                    .then(response => {
                        this.notes = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loadingNotes = false;
                    });
            },
            updateBrewSession() {
                HTTP.patch("brew-sessions/" +  this.id , { data: {
                        recipeId: this.brewSession.recipeId,
                        brew_session_og: this.og,
                        brew_session_fg: this.fg,
                        created_at: this.date,
                        brew_session_volume: this.volume ? this.volume + ' l' : undefined,
                    }
                })
                    .then(response => {
                        this.brewSession = response.data.data;
                        this.og = this.brewSession.og;
                        this.fg = this.brewSession.fg;
                        this.date = this.brewSession.date;
                        this.volume = this.$options.filters.grainWeightRaw(this.brewSession.volume);
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            addNote() {
                this.errors = [];
                this.errorFields = {};
                HTTP.post(`brew-sessions/${this.id}/notes`, { data: {
                        content: this.note,
                    }
                })
                    .then(response => {
                        this.note = '';
                        this.notes.push(response.data.data);
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                        _(this.errors[0]).each((errorItem) => {
                            this.errorFields[errorItem.field.replace('.', '_')] = errorItem.detail;
                        })
                    })
            },
            deleteNote(e) {
                if (confirm('Are you sure?')) {
                    this.errors = [];
                    this.errorFields = {};

                    const itemId = e.currentTarget.getAttribute('data-id');

                    HTTP.delete("brew-sessions/" + this.id + '/notes/' + itemId, {})
                        .then(response => {
                            this.fetchNotes();
                        })
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                            _(this.errors[0]).each((errorItem) => {
                                this.errorFields[errorItem.field.replace('.', '_')] = errorItem.detail;
                            })
                        })
                }
            },
        },
        beforeMount() {
            this.loggedIn = !!localStorage.username;
            this.id = parseInt(this.$route.params.id);
            EventBus.$on('logged-in', val => { this.loggedIn = val; });
        },
        mounted() {
            if (this.loggedIn) {
              EventBus.$on(`brew-session-data-changed:${this.id}`, this.fetchBrewSession);

              this.fetchBrewSession();
                this.fetchNotes();
            }
        },
    };
</script>

<style scoped lang="scss">
  .measured-inputs {
    display: flex;

    & > div {
      text-align: center;
    }
  }

  .brew-session-notes {
    margin-top: 1em;

    .notes-list {
      list-style-type: none;
      padding: 0;

      li {
        margin-bottom: 1em;
        position: relative;

        .delete-note {
          position: absolute;
          right: 0;
          top: 0;
        }
        .note-content {
          white-space: pre-wrap;
          word-wrap: break-word;
        }

        .note-date {
          display: block;
        }
      }

    }
  }

  .brew-record-data-actions button {
    margin: .25rem .125rem;
  }
</style>
